import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * A Collapsable Panel the transcludes it's inner html into the opened panel
 */
export class CollapsablePanel extends DirectiveBase {
  constructor() {
    super();

    this.restrict = 'E';
    this.transclude = true;
    this.scope = {
      panelTitle: '@'
    };

    this.templateUrl = 'app/angularJS/components/collapsable-panel/collapsable-panel.html';
    this.controller = 'CollapsablePanelController';
    this.controllerAs = 'vm';
    this.bindToController = true;
  }
}